export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_PET_INFO_ACTION';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_PET_INFO_ACTION';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_PET_INFO_ACTION';
export const DEFAULT = 'DEFAULT_PET_INFO_ACTION';
export const SET_PET_NAME = 'SET_PET_NAME';
export const SET_CLINIC_RECORD_NUMBER = 'SET_CLINIC_RECORD_NUMBER';
export const SET_MEALS_PER_DAY = 'SET_MEALS_PER_DAY';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
